/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["E H\xEBn\xEB", "E Mart\xEB", "E M\xEBrkur\xEB", "E Enjte", "E Premte", "E Shtun\xEB", "E Diel"], e = ["H\xEB", "Ma", "Mr", "Enj", "Pr", "Sh", "D"], t = ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "N\xEBntor", "Dhjetor"], r = "Vitet", s = "Viti", n = "Muaji", o = "Java", d = "Dita", i = "Sot", M = "Nuk ka event", h = "T\xEBr\xEB dit\xEBn", E = "Fshij\xEB", k = "Krijo nj\xEB event", y = "dddd D MMMM YYYY", D = { weekDays: a, weekDaysShort: e, months: t, years: "Vitet", year: "Viti", month: "Muaji", week: "Java", day: "Dita", today: "Sot", noEvent: "Nuk ka event", allDay: "T\xEBr\xEB dit\xEBn", deleteEvent: "Fshij\xEB", createEvent: "Krijo nj\xEB event", dateFormat: "dddd D MMMM YYYY" };
export {
  h as allDay,
  k as createEvent,
  y as dateFormat,
  d as day,
  D as default,
  E as deleteEvent,
  n as month,
  t as months,
  M as noEvent,
  i as today,
  o as week,
  a as weekDays,
  e as weekDaysShort,
  s as year,
  r as years
};
